import { inject, Injectable } from '@angular/core';
import { type ActivatedRouteSnapshot, type CanActivateChildFn, type CanActivateFn, Router } from '@angular/router';
import { PermissionService } from '@dm/core';
import { SWITCH } from 'app/config/switch';
import { type Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * 路由加载前检查对象的读权限
 */
@Injectable({ providedIn: 'root' })
class PermissionGuard {
    constructor(
        private permissionService: PermissionService,
        private router: Router,
    ) { }

    checkPermission(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
        if (!route.data) return true;

        const { permission, isSuperAdmin, depPermission, license, isVstoreNotAvaliable, isOceanMicroNotAvaliable, hide } = route.data;
        if (
            (permission && !this.permissionService.hasPermission(permission)) ||
            (license && !this.permissionService.isLicenseExist(license)) ||
            (isSuperAdmin && !this.permissionService.isSuperAdmin()) ||
            (SWITCH.IS_VSTORE_SYSTEM && isVstoreNotAvaliable) ||
            isOceanMicroNotAvaliable ||
            hide
        ) {
            this.router.navigate(['/404']);
            return false;
        }
        if (depPermission) {
            return this.permissionService.checkDepPermission(depPermission).pipe(
                map(() => true),
            );
        }
        return true;
    }
}

export const PermissionGuardCanActivate: CanActivateFn = (route: ActivatedRouteSnapshot): Observable<boolean> | boolean =>
    inject(PermissionGuard).checkPermission(route);

export const PermissionGuardCanActivateChild: CanActivateChildFn = (route: ActivatedRouteSnapshot): Observable<boolean> | boolean =>
    inject(PermissionGuard).checkPermission(route);
